import { render, staticRenderFns } from "./FolderControlItem.vue?vue&type=template&id=72c3db85&scoped=true"
import script from "./FolderControlItem.vue?vue&type=script&lang=js"
export * from "./FolderControlItem.vue?vue&type=script&lang=js"
import style0 from "./FolderControlItem.vue?vue&type=style&index=0&id=72c3db85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3db85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
